import defineMessages from "../../../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    play: {
        id: "audio.play",
    },
    check: {
        id: "audio.check",
    },
    submit: {
        id: "task.submit",
    },
});

export default messages;
